export class SetBeforeRoute {
  static readonly type = '[Route] Set before route';
  constructor(public beforeRoute: string) {}
}

export class RemoveBeforeRoute {
  static readonly type = '[Route] Remove before route';
}
